const complexCalculations = ['SUM(', 'CLASS(', 'DIVERSITY(', 'MEDIAN(', 'APC(', 'LOOKUP(', 'PERCENTILE(', '~'];

export const isReportFormulaIsTooComplex = (formula: string): boolean => {
  for (const calculation of complexCalculations) {
    if (formula.includes(calculation)) {
      return true;
    }
  }

  return false;
};

export const getFormulaDemographicIds = (formula: string): string[] => {
  const cleaned = formula.replace(/%/g, '');
  const matches = cleaned.match(/[A-Z][A-Z0-9]*/gi) || [];
  return [...new Set(matches)];
};
